import React from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import notFoundIcon from 'assets/icons/404-illustration.jpg';

const NotFoundPage = () => {
  const navigate = useNavigate();
  // 🧑‍⚖️ Check user role from localStorage
  const user = JSON.parse(localStorage.getItem('user_profile'));
  const userRole = user?.user_role;

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      // h={userRole?"calc(100dvh - 60px)":"100dvh"}
      h={'100dvh'}
      textAlign="center"
      px={6}
      bg="white"
    >
      <Box mb={6}>
        <img
          src={notFoundIcon}
          alt="notFoundIcon"
          style={{
            width: '75%',
            maxWidth: 550,
            height: 'auto',
            margin: '-40px auto',
          }}
        />
      </Box>

      {/* <Heading fontSize="3xl" mb={4} color="gray.800">
        404 - Page Not Found
      </Heading> */}
      <Text fontSize="lg" color="gray.600" mb={6} maxW="md">
        Sorry, the page you are looking for doesn’t exist or has been moved.
      </Text>

      <Button
        colorScheme="brand"
        size="md"
        // onClick={() => navigate('/admin/team')}
        onClick={() =>
          navigate(
            userRole === 'superadmin' ? '/admin/ai-agents' : '/admin/team',
          )
        }
      >
        Go Back
      </Button>
    </Flex>
  );
};

export default NotFoundPage;
